import { Link } from "react-router-dom";

const pageStyle = {
  minHeight: "100vh",
  background:
    "radial-gradient(1200px circle at top left, color-mix(in srgb, var(--c3) 45%, white 55%) 0%, transparent 38%), linear-gradient(180deg, #f8fcfd 0%, #ffffff 100%)",
};

const shellStyle = {
  background: "#fff",
  border: "1px solid var(--hairline)",
  borderRadius: "20px",
  padding: "2.5rem", // Increased padding for a more "document" feel
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
  width: "100%",
};

const sectionTitleStyle = {
  fontSize: "1.5rem",
  fontWeight: "700",
  color: "#1e293b",
  marginTop: "2rem",
  marginBottom: "1rem",
};

const listStyle = {
  paddingLeft: "1.5rem",
  marginBottom: "1rem",
};

export default function DeleteAccount() {
  return (
    <main style={pageStyle}>
      <div
        className="container"
        style={{
          paddingTop: "2rem",
          paddingBottom: "4rem",
          paddingLeft: "clamp(1rem, 4vw, 1.5rem)",
          paddingRight: "clamp(1rem, 4vw, 1.5rem)",
          maxWidth: "800px", // Keeps the text readable and centered
          margin: "0 auto",
        }}
      >
        <header
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
            marginBottom: "2rem",
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "0.85rem",
                fontWeight: 800,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "var(--ink-muted)",
              }}
            >
              BeFitFriends
            </div>
            <h1 style={{ margin: "0.25rem 0 0", fontSize: "clamp(2rem, 4vw, 3rem)" }}>
              Deleting Your Account
            </h1>
          </div>

          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0.85rem 1.1rem",
              borderRadius: "999px",
              border: "1px solid var(--hairline)",
              background: "#fff",
              fontWeight: 700,
              textDecoration: "none",
              color: "inherit",
            }}
          >
            Back home
          </Link>
        </header>

        <section
          style={{
            ...shellStyle,
            padding: "clamp(1.1rem, 4vw, 2.5rem)",
          }}
        >
          <div style={{ color: "var(--ink-muted)", marginBottom: "2rem" }}>
            <strong>Last Updated:</strong> July 15, 2026
          </div>

          <p>
            We hate to see you go! Here are the steps to delete your account:
          </p>

          <h2 style={sectionTitleStyle}>Send us an email</h2>
          <p>Send an email to our support team at support@befitfriends.com with your request to delete your account from the email address associated with your account.</p>
          <ul style={listStyle}>
            <address style={{ fontStyle: "normal", marginTop: "1rem", lineHeight: "1.6" }}>
            <strong>BeFitFriends LLC</strong><br />
            Email: <a href="mailto:support@befitfriends.com">support@befitfriends.com</a>
          </address>
          </ul>

          <h2 style={sectionTitleStyle}>What happens next?</h2>
          <p>Once we receive your request, we will process it within 7 business days. You will receive a confirmation email once your account has been successfully deleted.</p>
          
        </section>
      </div>
    </main>
  );
}